import React, { useEffect } from "react";
import { useNavigate, NavLink, Outlet } from "react-router-dom";
import { getAccessToken } from "../utils/fetchFunctions";
import "./dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <main className="dashboard-page">
      <div className="dashboard-container">
        <nav className="dashboard-subnav">
          <NavLink
            to="/dashboard/overview"
            className={({ isActive }) =>
              `dashboard-subnav-link${isActive ? " dashboard-subnav-link--active" : ""}`
            }
          >
            Maturity Overview
          </NavLink>
          <NavLink
            to="/dashboard/radar"
            className={({ isActive }) =>
              `dashboard-subnav-link${isActive ? " dashboard-subnav-link--active" : ""}`
            }
          >
            Maturity Radar
          </NavLink>
          <NavLink
            to="/dashboard/levels"
            className={({ isActive }) =>
              `dashboard-subnav-link${isActive ? " dashboard-subnav-link--active" : ""}`
            }
          >
            Level Achievement
          </NavLink>
          <NavLink
            to="/dashboard/next-steps"
            className={({ isActive }) =>
              `dashboard-subnav-link${isActive ? " dashboard-subnav-link--active" : ""}`
            }
          >
            Next Steps
          </NavLink>
        </nav>
        <Outlet />
      </div>
    </main>
  );
};

export default Dashboard;
